import api from './api';
import app from './app';
import firebase from './firebase';
import plugins from './plugins';
import useQuery from './useQuery';

export { api, app, app as config, firebase, plugins, useQuery };
export default { app, api, config: app, useQuery, plugins, firebase };
